export const Namespace = 'TRASH';
export enum TrashAction {
    Purge = 'PURGE',
    Restore = 'RESTORE',
    PurgeSelected = 'PURGE_SELECTED',
    PurgeAll = 'PURGE_ALL',
    RestoreSelected = 'RESTORED_SELECTED',
    RestoreAll = 'RESTORE_ALL'
};


// WEBPACK FOOTER //
// ./src/sharebase-app/components/deletedItems/deletedItems.actions.ts